export default {"src":"/_next/static/media/logo_white.d31d0dd6.svg","height":2024,"width":2074,"blurWidth":0,"blurHeight":0};